import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { Tooltip } from '@material-ui/core';
import { colors, fontSize, maskTextStyles } from '../../constants/styleConstants';
import NextLink from '../NextLink';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: '16px !important',
  },
  badge: {
    borderRadius: '11.5px',
    backgroundColor: 'rgb(58, 58, 58, 0.2)',
    color: '#757575',
    fontSize: fontSize.smallTitle,
    fontWeight: 'bold',
    minWidth: '30px',
    height: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 2,
    paddingLeft: 2,
  },
  content: {
    fontSize: fontSize.medium,
    color: colors.grey2,
    marginLeft: 3,
  },
  link: {
    color: colors.blueChip,
    fontSize: fontSize.medium,
    '&:hover': {
      color: colors.blueChip,
    },
  },
  maskText: {
    cursor: 'pointer',
    textShadow: '0 0 5px rgb(0, 103, 197, 0.4)',
    ...maskTextStyles,
  },
}));

const CustomChips = ({ label, content, className, type, linkProps, linkName, isArchived, checkPermissions }) => {
  const classes = useStyles();
  return (
    <div className={classnames(classes.root, className)}>
      <Tooltip title={content}>
        <span className={classes.badge}>{label}</span>
      </Tooltip>
      {type !== 'small' && <span className={classes.content}>{content}</span>}
      {linkName &&
        linkProps &&
        (isArchived ? (
          <span onClick={checkPermissions} className={classnames(classes.link, classes.maskText)}>
            ({linkName})
          </span>
        ) : (
          <NextLink {...linkProps} className={classes.link}>
            <span>&nbsp; ({linkName}) </span>
          </NextLink>
        ))}
    </div>
  );
};

CustomChips.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  content: PropTypes.string,
};

CustomChips.defaultProps = {};

export default memo(CustomChips);
